module.exports = __webpack_public_path__ + "img/2023080309294953798x.39e02770.jpg";